import { Card, CardContent, CardDescription, CardHeader, CardTitle, Avatar, Badge } from '@klaro7/ui';
import { UserRole } from '@klaro7/shared-types';

import { useAuth } from '@/features/auth/hooks/useAuth';
import { ConsultantProfilePage } from '@/features/professional-profile/components/ConsultantProfilePage';

export function ProfilePage() {
  const { user, hasRole } = useAuth();

  if (!user) return null;

  // Show consultant profile for professional role
  if (hasRole(UserRole.PROFESSIONAL)) {
    return <ConsultantProfilePage />;
  }

  const fullName = `${user.profile?.firstName || ''} ${user.profile?.lastName || ''}`.trim();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-neutral-900">Profilo</h1>
        <p className="text-neutral-500">Gestisci le informazioni del tuo account</p>
      </div>

      <div className="grid gap-6 lg:grid-cols-3">
        <Card className="lg:col-span-1">
          <CardContent className="flex flex-col items-center pt-6">
            <Avatar fallback={fullName || user.email} size="xl" />
            <h2 className="mt-4 text-lg font-semibold text-neutral-900">{fullName || 'Utente'}</h2>
            <p className="text-sm text-neutral-500">{user.email}</p>
            <Badge variant="primary" className="mt-2 capitalize">
              {user.role.replace('_', ' ')}
            </Badge>
          </CardContent>
        </Card>

        <Card className="lg:col-span-2">
          <CardHeader>
            <CardTitle>Informazioni personali</CardTitle>
            <CardDescription>I tuoi dati personali</CardDescription>
          </CardHeader>
          <CardContent>
            <dl className="grid gap-4 sm:grid-cols-2">
              <div>
                <dt className="text-sm font-medium text-neutral-500">Nome</dt>
                <dd className="mt-1 text-sm text-neutral-900">{user.profile?.firstName || '-'}</dd>
              </div>
              <div>
                <dt className="text-sm font-medium text-neutral-500">Cognome</dt>
                <dd className="mt-1 text-sm text-neutral-900">{user.profile?.lastName || '-'}</dd>
              </div>
              <div>
                <dt className="text-sm font-medium text-neutral-500">Email</dt>
                <dd className="mt-1 text-sm text-neutral-900">{user.email}</dd>
              </div>
              <div>
                <dt className="text-sm font-medium text-neutral-500">Telefono</dt>
                <dd className="mt-1 text-sm text-neutral-900">{user.profile?.phone || '-'}</dd>
              </div>
              <div>
                <dt className="text-sm font-medium text-neutral-500">Stato</dt>
                <dd className="mt-1">
                  <Badge variant={user.status === 'active' ? 'success' : 'warning'} className="capitalize">
                    {user.status}
                  </Badge>
                </dd>
              </div>
              <div>
                <dt className="text-sm font-medium text-neutral-500">Registrato il</dt>
                <dd className="mt-1 text-sm text-neutral-900">
                  {new Date(user.createdAt).toLocaleDateString('it-IT', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  })}
                </dd>
              </div>
            </dl>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
